module.exports = __webpack_public_path__ + "static/media/lost.1ba8e884.svg";